export const SUPER_ADMIN_ROLE_ID = '3';
export const PRINT_IN_CONSOLE = true;